/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { getClientHints } from '../utils/PRIVATE_clientHints';
import { DataState } from '../UNSAFE_Collection';

/**
 * Helper function to determine whether the current device is a mobile device
 * @returns true if running on a mobile device, false otherwise
 */
export function isMobile() {
  const deviceType = getClientHints().deviceType;
  return deviceType === 'phone' || deviceType === 'tablet';
}

/**
 * Helper function to determine whether the current device is a phone
 * @returns true if running on a phone, false otherwise
 */
export function isPhone() {
  return getClientHints().deviceType === 'phone';
}

/**
 * Helper function to determine whether the current device is a tablet
 * @returns true if running on a tablet, false otherwise
 */
export function isTablet() {
  return getClientHints().deviceType === 'tablet';
}

export function isBeforeDataFetch<K, D>(data: DataState<K, D>) {
  return data.sizePrecision === 'atLeast' && data.totalSize === 0;
}
